import hasPermi from "./hasPermi.js";
function directive(app) {
    app.directive('hasPermi', hasPermi)
}

export default directive;